import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter, ViewChild, ElementRef } from '@angular/core';

import { MethodofOperation } from "@app/shared/constants/methodofOperation";

declare var Highcharts: any;

@Component({
    selector: 'sst-graph-chart',
    templateUrl: './sst-graph-chart.component.html'
})

export class SSTGraphChartComponent implements OnInit, OnChanges {

    @ViewChild("chartTarget")
    chartTarget: ElementRef;
    @Input()
    graphList: any;

    chart: any;
    chartType: string;
    methodOfOperation: string;
    userProfileDataStatusDat: boolean;
    graphDataList: Array<any>;
    initialData: Array<any>;
    marketData: any;
    xAxisLabel = "";
    yAxisLabel = "";
    height = 320;
    width = 530;
    benchType: string;
    benchmarkingToggle: boolean;
    userSelection: any = {};
    selection: boolean;
    secondaryChoices: any = [];

    chartInitialValue = 0;
    chartFinalValue = 0;
    chartSelectedValue;
    timelineToggle: boolean;
    topValueFilterData: any = 0;
    description: string;
    showBeshmarkFilter: boolean = false;

    mOOperationMapping = MethodofOperation.mapping;

    benchMarkStatus: boolean = false;
    isNumericBenchMark: boolean = false;
    showUserSelectionMenu: boolean = false;
    showNumericSelectionMenu: boolean = false;
    nGraphValue: any;


    @Input()
    set graphData(data: Array<any>) {
        if (data) {
            this.initialData = data;
            this.graphDataList = data;
            this.generateChart();
        }
    }

    @Input()
    set secondaryData(data: Array<any>) {
        if (data) {
            this.secondaryChoices = data;
            this.generateChart();
        }
    }

    @Input()
    set graphType(type: string) {
        if (type) {
            this.chartType = type;
            this.generateChart();
        }
    }

    @Input()
    set heightInput(val: number) {
        if (val) {
            this.height = val;
        } else {
            this.height = 380;
        }
    }

    @Input()
    set widthInput(val: number) {
        if (val) {
            this.width = val;
        } else {
            this.width = 400;
        }
    }

    @Input()
    set operationType(val: string) {
        this.methodOfOperation = val;
        this.generateChart();
    }

    constructor(
    ) { }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges) {
    }

    generateChart() {


        if (this.graphDataList && this.methodOfOperation && !this.userProfileDataStatusDat) {
            switch (this.chartType) {
                case "Bar": {
                    const xAxisData: Array<string> = [];
                    const barData: Array<number> = [];
                    this.graphDataList.forEach(graphData => {
                        let stackedBar: boolean = false;
                        if (graphData.grouping) {
                            stackedBar = true;
                        } else {
                            stackedBar = false;
                        }
                        if (this.topValueFilterData > 0 && (+graphData.doc_percentage > 0 || +graphData.doc_count > 0)) {
                            if (graphData.label) {
                                xAxisData.push(graphData.label);
                            } else if (graphData.text) {
                                xAxisData.push(graphData.text);
                            }

                            if (!stackedBar) {
                                barData.push(
                                    this.methodOfOperation == 'Percentage' ? +graphData.doc_percentage : +graphData.doc_count
                                );
                            } else if (stackedBar) {
                                barData.push(
                                    this.methodOfOperation == 'Percentage' ? +graphData.grouping[0].doc_percentage : +graphData.grouping[0].doc_count
                                );
                            }

                        } else if (this.topValueFilterData <= 0) {
                            if (graphData.label) {
                                xAxisData.push(graphData.label);
                            } else if (graphData.text) {
                                xAxisData.push(graphData.text);
                            }
                            if (!stackedBar) {
                                barData.push(
                                    this.methodOfOperation == 'Percentage' ? +graphData.doc_percentage : +graphData.doc_count
                                );
                            } else if (stackedBar) {
                                barData.push(
                                    this.methodOfOperation == 'Percentage' ? +graphData.grouping[0].doc_percentage : +graphData.grouping[0].doc_count
                                );
                            }
                        }
                    });

                    const options: any = {
                        chart: {
                            type: "column",
                            width: this.width,
                            height: this.height
                        },
                        title: {
                            text: ""
                        },
                        xAxis: {
                            categories: xAxisData,
                            title: {
                                text: this.xAxisLabel
                            }
                        },
                        yAxis: {
                            tickInterval: this.chartSelectedValue,
                            title: {
                                text: this.yAxisLabel
                            }
                        },
                        series: [
                            {
                                name: this.methodOfOperation,
                                data: barData
                            }
                        ],
                        colors: ["#d8504e"],
                        exporting: {
                          enabled: false,
                        }
                    };
                    this.chart = Highcharts.chart(
                        this.chartTarget.nativeElement,
                        options
                    );
                    break;
                }
                case "Pie": {
                    const pieData: Array<object> = [];
                    this.graphDataList.forEach(graphData => {
                        if (graphData.doc_percentage > 0 || graphData.doc_count > 0) {
                            pieData.push({
                                name: graphData.text,
                                y: graphData.doc_percentage
                            });
                        }
                    });

                    const options: any = {
                        chart: {
                            type: "pie",
                            width: this.width,
                            height: this.height
                        },
                        title: {
                            text: ""
                        },
                        tooltip: {
                            pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                        },
                        series: [
                            {
                                name: this.methodOfOperation,
                                data: pieData
                            }
                        ],
                        exporting: {
                          enabled: false,
                        }
                    };
                    this.chart = Highcharts.chart(
                        this.chartTarget.nativeElement,
                        options
                    );
                    break;
                }
                case "Doughnut": {
                    const pieData: Array<object> = [];
                    this.graphDataList.forEach(graphData => {
                        pieData.push({
                            name: graphData.text || graphData.label,
                            y: graphData[this.mOOperationMapping[this.methodOfOperation]]
                        });
                    });

                    const options: any = {
                        chart: {
                            type: "pie",
                            width: this.width,
                            height: this.height
                        },
                        plotOptions: {
                            pie: {
                                allowPointSelect: true,
                                cursor: true,
                                innerSize: "60%",
                                dataLabels: {
                                    enabled: true
                                },
                                shadow: false,
                                center: ["50%", "50%"]
                            },
                            series: {
                                animation: true
                            }
                        },
                        title: {
                            text: ""
                        },
                        tooltip: {
                            pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                        },
                        series: [
                            {
                                name: this.methodOfOperation,
                                data: pieData
                            }
                        ],
                        exporting: {
                          enabled: false,
                        }
                    };
                    this.chart = Highcharts.chart(
                        this.chartTarget.nativeElement,
                        options
                    );
                    break;
                }
                case "Line chart": {
                    const pieData: Array<object> = [];
                    this.graphDataList.forEach(graphData => {
                        if (graphData.doc_percentage > 0 || graphData.doc_count > 0) {
                            pieData.push({
                                name: graphData.text,
                                y: graphData[this.mOOperationMapping[this.methodOfOperation]]
                            });
                        }
                    });

                    const options: any = {
                        chart: {
                            width: this.width,
                            height: this.height
                        },
                        title: {
                            text: ""
                        },
                        series: [
                            {
                                name: this.methodOfOperation,
                                data: pieData
                            }
                        ],
                        plotOptions: {
                            series: {
                                label: {
                                    connectorAllowed: false
                                }
                            }
                        },
                        legend: {
                            layout: "vertical",
                            align: "right",
                            verticalAlign: "middle"
                        },
                        exporting: {
                          enabled: false,
                        }
                    };
                    this.chart = Highcharts.chart(
                        this.chartTarget.nativeElement,
                        options
                    );
                    break;
                }
            }
        } else if (this.graphDataList && this.methodOfOperation && this.userProfileDataStatusDat) {
            switch (this.chartType) {
                case "Bar": {
                    const xAxisData: Array<string> = [];
                    const barData: Array<number> = [];
                    this.graphDataList.forEach(graphData => {
                        if (graphData.doc_percentage > 0 || graphData.doc_count > 0) {
                            if (graphData.label) {
                                xAxisData.push(graphData.label);
                            } else if (graphData.text) {
                                xAxisData.push(graphData.text);
                            }

                            barData.push(
                                this.methodOfOperation == 'Percentage' ? graphData.doc_percentage : graphData.doc_count
                            );
                        }
                    });

                    const options: any = {
                        chart: {
                            type: "column",
                            width: this.width,
                            height: this.height
                        },
                        title: {
                            text: ""
                        },
                        xAxis: {
                            categories: xAxisData,
                            title: {
                                text: this.xAxisLabel
                            }
                        },
                        yAxis: {
                            tickInterval: this.chartSelectedValue,
                            title: {
                                text: this.yAxisLabel
                            }
                        },
                        series: [
                            {
                                name: this.methodOfOperation,
                                data: barData
                            }
                        ],
                        colors: ["#d8504e"],
                        exporting: {
                          enabled: false,
                        }
                    };

                    this.chart = Highcharts.chart(
                        this.chartTarget.nativeElement,
                        options
                    );
                    break;
                }
                case "Pie": this.marketData ? this.generatePieChart() : undefined;
            }
        }
        else {
            const options: any = {};
            this.chart = Highcharts.chart(this.chartTarget.nativeElement, options);
        }
    }

    generatePieChart() {
        var json = {
            responsive: {
                rules: [{
                    condition: {
                        maxWidth: 500
                    },
                    chartOptions: {
                        legend: {
                            align: 'center',
                            verticalAlign: 'bottom',
                            layout: 'horizontal'
                        }
                    }
                }]
            },
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },
            title: {
                text: this.marketData.title
            },
            tooltip: {
                pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format: '<b>{point.name}</b>: {point.percentage:.1f} %',
                    }
                }
            },
            series: [{
                name: 'Brands',
                colorByPoint: true,
                data: this.generatePieChartXY('both')
            }]
        }

        return json
    }

    generatePieChartXY(type: any) {
        let returnData: any = {}
        let mapedText: Array<String> = [];
        let mapedData: Array<any> = [];
        let seriesData: any = [];

        this.marketData.choices.forEach(choices => {
            this.marketData.marketData.forEach(docCount => {
                if (choices.id == docCount.key) {
                    if (docCount.doc_percentage > 0 || docCount.doc_count > 0) {
                        mapedText.push(choices.text);
                        mapedData.push(docCount.doc_count)
                        seriesData.push({
                            name: choices.text,
                            y: docCount.doc_count
                        })
                    }
                }
            });
        });
        returnData = type == 'category' ? mapedText : type == 'data' ? mapedData : type == 'both' ? seriesData : null
        return returnData;
    }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/self-service-tab/components/sst-graph-chart/sst-graph-chart.component.ts